import { Splide } from '@splidejs/splide';

export const testimonialsSlider = () => {
    const $ = jQuery;

    const wrappers = $('.testimonial-slider');

    if (wrappers.length === 0) {
        return true;
    }

    wrappers.each((i, wrapper) => {
        const slider = new Splide( wrapper, {
            autoHeight: true
        } );

        slider.mount();
    });
};